import { lazy } from 'react';

const QuoteDetails = lazy(() => import('./QuoteDetails'));

const QuoteConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'quote/:quoteId/:defaultTab',
      element: <QuoteDetails />,
    },
    {
      path: 'quote/:quoteId/*',
      element: <QuoteDetails />,
    },
  ],
};

export default QuoteConfig;
